import { z } from 'zod';

export const OfferStatus = z.enum(['pending', 'accepted', 'declined', 'partial']);
export type OfferStatus = z.infer<typeof OfferStatus>;

export const ServiceWindowOffer = z.object({
  id: z.string().uuid(),
  windowId: z.string().uuid(),
  vendorId: z.string().uuid(),
  status: OfferStatus,
  /** Required when status === 'partial'; null/omitted otherwise. */
  confirmedCapacity: z.number().int().min(1).max(50).nullable().optional(),
  notes: z.string().max(2000).optional(),
  decidedAt: z.string().datetime().nullable().optional(),
  /** Optional hint — the vehicle the vendor is returning the same trip. */
  pairedDropoffVehicleId: z.string().uuid().nullable().optional(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type ServiceWindowOffer = z.infer<typeof ServiceWindowOffer>;

export const UpdateOfferInput = z
  .object({
    status: OfferStatus,
    confirmedCapacity: z.number().int().min(1).max(50).optional(),
    notes: z.string().max(2000).optional(),
    pairedDropoffVehicleId: z.string().uuid().nullable().optional(),
  })
  .refine(
    (d) =>
      d.status !== 'partial' ||
      (typeof d.confirmedCapacity === 'number' && d.confirmedCapacity >= 1),
    { message: 'partial status requires confirmedCapacity >= 1', path: ['confirmedCapacity'] },
  );
export type UpdateOfferInput = z.infer<typeof UpdateOfferInput>;
